<template>
  <div class="v2-blog-related-posts">
    <h2 class="mb-3 mb-md-4">
      {{ t("Related posts") }}
    </h2>

    <div class="related-posts-wrapper">
      <div v-for="post in posts" :key="post.id" class="item">
        <blog-list-item :post="post" />
      </div>
    </div>

    <div v-if="!hasAgeVerificationFeature" class="d-flex justify-content-center mt-4">
      <router-link :to="getBlogUrl()" class="btn btn-primary wide">
        {{ t("View all") }}
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from "vue";
import BlogListItem from "@/components/v2/blog-list-item/index.vue";
import { getBlogUrl } from "@/utils/urlHelper";
import { BlogPost } from "@/interfaces/Blog/BlogPost.ts";
import { useI18n } from "vue-i18n";
import { useFeatureStore } from "@/store/feature.ts";

defineOptions({
  name: "blog-related-posts-v2",
});

defineProps({
  posts: {
    type: Array as PropType<BlogPost[]>,
    required: true,
  },
});

const { t } = useI18n();
const featureStore = useFeatureStore();
const hasAgeVerificationFeature = computed(() => featureStore.hasAgeVerificationFeature);
</script>

<style lang="scss">
@import "./index";
</style>
